import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'detail-growth-chart',
  extends: Line,
  mixins: [reactiveProp],
  props: [
    'scale'
  ],
  data() {
    return {
      options: {
        borderCapStyle: 'butt',
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
        },
        tooltips: {
          mode: 'index',
          position: 'nearest',
          enabled: false,
          callbacks: {
              label: function(tooltipItem, data) {
                const label = data.datasets[tooltipItem.datasetIndex].label
                return `${label.substring(0, label.indexOf('('))}: ${tooltipItem.yLabel.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              },
          },
          custom: function(tooltipModel) {
            var tooltipEl = document.getElementById('chartjs-tooltip')

            if (!tooltipEl) {
                tooltipEl = document.createElement('div')
                tooltipEl.id = 'chartjs-tooltip'
                tooltipEl.innerHTML = '<table></table>'
                tooltipEl.style.backgroundColor = "rgba(255, 255, 255)"
                tooltipEl.style.borderColor = "grey"
                tooltipEl.style.borderWidth = "thin"
                tooltipEl.style.borderStyle = "solid"
                document.body.appendChild(tooltipEl)
            }

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = 0;
                return;
            }

            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform');
            if (tooltipModel.yAlign) {
                tooltipEl.classList.add(tooltipModel.yAlign);
            } else {
                tooltipEl.classList.add('no-transform');
            }

            function getBody(bodyItem) {
                return bodyItem.lines;
            }

            // Set Text
            if (tooltipModel.body) {
                var titleLines = tooltipModel.title || [];
                var bodyLines = tooltipModel.body.map(getBody)

                var innerHtml = '<thead>'

                titleLines.forEach(function(title) {
                    innerHtml += `<tr><th colspan="3" style="font-size: 14px">${title}</th></tr>`
                })
                innerHtml += '</thead><tbody>'

                bodyLines.forEach(function(body, i) {
                    const colors = tooltipModel.labelColors[i]
                    const text = body[0].split(":")
                    innerHtml += `<tr>
                    <td style="width: 15px; background: ${colors.backgroundColor}"></td>
                    <td>${text[0]}</td>
                    <td align="right">${text[1]}</td>
                    </tr>`
                });
                innerHtml += '</tbody>'

                var tableRoot = tooltipEl.querySelector('table')
                tableRoot.innerHTML = innerHtml;
            }

            // `this` will be the overall tooltip
            var position = this._chart.canvas.getBoundingClientRect();

            // Display, position, and set styles for font
            let left = position.left + window.pageXOffset + tooltipModel.caretX + 10
            if (left + tooltipModel.width > window.innerWidth) left = left - tooltipModel.width - 20

            tooltipEl.style.opacity = 1
            tooltipEl.style.position = 'absolute'
            tooltipEl.style.left = `${left}px`
            tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY / 2 + 'px'
            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
            tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px'
            tooltipEl.style.pointerEvents = 'none'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
                userCallback: function(value, index, values) {
                    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                }
              }
            }]
        },
      }
    }
  },
  watch: {
    scale(value) {
      const scaleString = value? 'logarithmic' : 'linear'
      this.options.scales.yAxes[0].type = scaleString
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  destroyed() {
    const tooltip = document.getElementById('chartjs-tooltip')
    if (tooltip) tooltip.remove()
  }
}